module.exports = __webpack_public_path__ + "img/logo.6fff3d99.png";